// @ts-nocheck
import {useState, useEffect, useCallback} from 'react'
import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL || ''

const DAY_NAMES = ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש']
const DAY_NAMES_FULL = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת']

function getHoursForDay(dayIndex: number): number[] {
  if (dayIndex === 5) return Array.from({length: 8}, (_, i) => i + 7) // Friday 7-14
  if (dayIndex === 6) return [21, 22, 23] // Saturday 21-23
  return Array.from({length: 17}, (_, i) => i + 7) // 7-23
}

function getAuthHeaders() {
  const authToken = localStorage.getItem('kt-auth-react-v')
  if (!authToken) return {}
  const parsed = JSON.parse(authToken)
  if (!parsed?.api_token) return {}
  return {Authorization: `Bearer ${parsed.api_token}`}
}

function formatFollowers(count?: number): string {
  if (!count) return ''
  if (count >= 1000000) return `${(count / 1000000).toFixed(1)}M`
  if (count >= 1000) return `${(count / 1000).toFixed(1)}K`
  return count.toString()
}

function getSettingsSummary(gs: any): string {
  if (!gs || !gs.schedule || Object.keys(gs.schedule).length === 0) return 'ברירת מחדל'
  const days = Object.keys(gs.schedule).map(d => DAY_NAMES[parseInt(d)]).join(' ')
  const maxStr = gs.max_per_day ? ` | מקס׳ ${gs.max_per_day}` : ''
  return `${days}${maxStr}`
}

function GroupSettings({
  groupId,
  settings,
  onChange,
  onClear,
}: {
  groupId: string
  settings: any
  onChange: (gs: any) => void
  onClear: () => void
}) {
  const schedule = settings?.schedule || {}
  const enabledDays = Object.keys(schedule).map(Number)
  const maxPerDay = settings?.max_per_day || ''

  const toggleDay = (day: number) => {
    const newSchedule = {...schedule}
    if (newSchedule[day]) {
      delete newSchedule[day]
    } else {
      const hours = getHoursForDay(day)
      newSchedule[day] = [hours[0]]
    }
    onChange({...settings, schedule: newSchedule})
  }

  const toggleHour = (day: number, hour: number) => {
    const newSchedule = {...schedule}
    const dayHours = newSchedule[day] || []
    if (dayHours.length === 1 && dayHours[0] === hour) {
      // Deselect — remove the day entirely
      delete newSchedule[day]
    } else {
      // Select this hour (replacing any previous selection)
      newSchedule[day] = [hour]
    }
    onChange({...settings, schedule: newSchedule})
  }

  return (
    <div style={{
      background: '#f8f9fa',
      borderRadius: '8px',
      padding: '16px',
      marginTop: '8px',
      border: '1px solid #e9ecef'
    }}>
      <div style={{marginBottom: '12px'}}>
        <label style={{fontWeight: 600, fontSize: '13px', marginBottom: '8px', display: 'block'}}>ימים:</label>
        <div style={{display: 'flex', gap: '6px', flexWrap: 'wrap'}}>
          {DAY_NAMES.map((name, i) => (
            <button
              key={i}
              onClick={() => toggleDay(i)}
              style={{
                width: '40px',
                height: '36px',
                borderRadius: '8px',
                border: enabledDays.includes(i) ? '2px solid #0d6efd' : '1px solid #dee2e6',
                background: enabledDays.includes(i) ? '#0d6efd' : '#fff',
                color: enabledDays.includes(i) ? '#fff' : '#333',
                fontWeight: 600,
                fontSize: '14px',
                cursor: 'pointer',
              }}
            >
              {name}
            </button>
          ))}
        </div>
      </div>

      {enabledDays.sort((a, b) => a - b).map(day => {
        const dayHours = schedule[day] || []
        const availableHours = getHoursForDay(day)
        return (
          <div key={day} style={{marginBottom: '10px'}}>
            <label style={{fontSize: '12px', color: '#666', marginBottom: '4px', display: 'block'}}>
              יום {DAY_NAMES_FULL[day]}:
            </label>
            <div style={{display: 'flex', gap: '4px', flexWrap: 'wrap'}}>
              {availableHours.map(h => (
                <button
                  key={h}
                  onClick={() => toggleHour(day, h)}
                  style={{
                    minWidth: '36px',
                    height: '30px',
                    borderRadius: '15px',
                    border: dayHours.includes(h) ? '2px solid #0d6efd' : '1px solid #dee2e6',
                    background: dayHours.includes(h) ? '#0d6efd' : '#fff',
                    color: dayHours.includes(h) ? '#fff' : '#666',
                    fontSize: '12px',
                    fontWeight: dayHours.includes(h) ? 600 : 400,
                    cursor: 'pointer',
                    padding: '0 8px',
                  }}
                >
                  {h}:00
                </button>
              ))}
            </div>
          </div>
        )
      })}

      <div style={{marginTop: '12px', display: 'flex', alignItems: 'center', gap: '12px'}}>
        <label style={{fontSize: '13px', fontWeight: 600, whiteSpace: 'nowrap'}}>מקס׳ ליום:</label>
        <input
          type="number"
          min="1"
          max="100"
          value={maxPerDay}
          onChange={(e) => {
            const val = e.target.value ? parseInt(e.target.value) : undefined
            const newSettings = {...settings}
            if (val) {
              newSettings.max_per_day = val
            } else {
              delete newSettings.max_per_day
            }
            onChange(newSettings)
          }}
          placeholder="ללא הגבלה"
          style={{
            width: '120px',
            height: '32px',
            borderRadius: '6px',
            border: '1px solid #dee2e6',
            padding: '0 8px',
            fontSize: '13px',
          }}
        />
        <button
          onClick={onClear}
          style={{
            marginRight: 'auto',
            background: 'none',
            border: '1px solid #dc3545',
            color: '#dc3545',
            borderRadius: '6px',
            padding: '4px 12px',
            fontSize: '12px',
            cursor: 'pointer',
          }}
        >
          נקה הגדרות
        </button>
      </div>
    </div>
  )
}

function GroupSchedulingWrapper() {
  const [campaigns, setCampaigns] = useState<any[]>([])
  const [slots, setSlots] = useState<any>({})
  const [groups, setGroups] = useState<any>({})
  const [selectedCampaign, setSelectedCampaign] = useState<string>('')
  const [groupSettings, setGroupSettings] = useState<any>({})
  const [expandedGroup, setExpandedGroup] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [saveMessage, setSaveMessage] = useState('')

  const fetchData = useCallback(async () => {
    try {
      setLoading(true)
      const response = await axios.get(`${API_URL}/api/group-scheduling-campaigns`, {
        headers: getAuthHeaders(),
      })
      setCampaigns(response.data.campaigns || [])
      setSlots(response.data.slots || {})
      setGroups(response.data.groups || {})

      // Auto-select first campaign
      if (response.data.campaigns?.length > 0 && !selectedCampaign) {
        const firstId = response.data.campaigns[0]._id
        setSelectedCampaign(firstId)
        setGroupSettings(response.data.slots[firstId]?.group_settings || {})
      }
    } catch (e) {
      console.error('Error fetching group scheduling data:', e)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  const handleCampaignChange = (campaignId: string) => {
    setSelectedCampaign(campaignId)
    setGroupSettings(slots[campaignId]?.group_settings || {})
    setExpandedGroup(null)
    setLibSearchQ('')
    setLibSearchResults([])
  }

  // ---- Account-scoped extra groups for a (shared) library ----
  const [libSearchQ, setLibSearchQ] = useState('')
  const [libSearchResults, setLibSearchResults] = useState<any[]>([])
  const [libSearching, setLibSearching] = useState(false)
  const [libTarget, setLibTarget] = useState<string>('') // target library id to add into
  const [libBusy, setLibBusy] = useState(false)

  // Debounced group search.
  useEffect(() => {
    const q = libSearchQ.trim()
    if (q.length < 2) { setLibSearchResults([]); return }
    let cancelled = false
    setLibSearching(true)
    const t = setTimeout(async () => {
      try {
        const r = await axios.get(`${API_URL}/api/account-library-groups-search`, {params: {q}, headers: getAuthHeaders()})
        if (!cancelled) setLibSearchResults(r.data?.groups || [])
      } catch { if (!cancelled) setLibSearchResults([]) }
      finally { if (!cancelled) setLibSearching(false) }
    }, 350)
    return () => { cancelled = true; clearTimeout(t) }
  }, [libSearchQ])

  const addGroupToLibrary = async (group: any) => {
    const targetLib = libTarget || (campaignLibs[0]?._id?.toString() || '')
    if (!targetLib) { alert('לקמפיין זה אין ספריית קבוצות לצרף אליה'); return }
    setLibBusy(true)
    try {
      await axios.post(`${API_URL}/api/account-library-groups/${targetLib}/add`, {group_ids: [group._id.toString()]}, {headers: getAuthHeaders()})
      // Reflect locally: add to the campaign's account_library_groups + group details.
      setGroups((prev: any) => ({...prev, [group._id.toString()]: {_id: group._id, name: group.name, image_url: group.image_url, follow_count: group.follow_count}}))
      setSlots((prev: any) => {
        const cur = prev[selectedCampaign] || {}
        const next = new Set([...(cur.account_library_groups || []).map((g: any) => g.toString()), group._id.toString()])
        return {...prev, [selectedCampaign]: {...cur, account_library_groups: [...next]}}
      })
      setLibSearchQ(''); setLibSearchResults([])
    } catch (e: any) {
      alert('הוספת הקבוצה נכשלה: ' + (e?.response?.data?.error || e?.message))
    } finally { setLibBusy(false) }
  }

  const removeGroupFromLibrary = async (groupId: string) => {
    setLibBusy(true)
    try {
      // The group lives in exactly one of the campaign's library overlays; pull from all.
      await Promise.all(campaignLibs.map((lib: any) =>
        axios.post(`${API_URL}/api/account-library-groups/${lib._id}/remove`, {group_ids: [groupId]}, {headers: getAuthHeaders()}).catch(() => {})
      ))
      setSlots((prev: any) => {
        const cur = prev[selectedCampaign] || {}
        return {...prev, [selectedCampaign]: {...cur, account_library_groups: (cur.account_library_groups || []).map((g: any) => g.toString()).filter((g: string) => g !== groupId)}}
      })
    } catch (e: any) {
      alert('הסרת הקבוצה נכשלה: ' + (e?.response?.data?.error || e?.message))
    } finally { setLibBusy(false) }
  }

  const handleSave = async () => {
    try {
      setSaving(true)
      setSaveMessage('')
      await axios.post(`${API_URL}/api/save-group-scheduling`, {
        campaignId: selectedCampaign,
        groupSettings,
      }, {
        headers: getAuthHeaders(),
      })
      setSlots((prev: any) => ({
        ...prev,
        [selectedCampaign]: {
          ...prev[selectedCampaign],
          group_settings: groupSettings,
        },
      }))
      setSaveMessage('ההגדרות נשמרו בהצלחה')
      setTimeout(() => setSaveMessage(''), 3000)
    } catch (e) {
      console.error('Error saving:', e)
      setSaveMessage('שגיאה בשמירה')
    } finally {
      setSaving(false)
    }
  }

  const currentSlot = slots[selectedCampaign]
  const campaignGroupIds: string[] = []
  if (currentSlot) {
    ;(currentSlot.selected_groups || []).forEach((gId: string) => {
      if (!campaignGroupIds.includes(gId)) campaignGroupIds.push(gId)
    })
    ;(currentSlot.group_libraries || []).forEach((lib: any) => {
      ;(lib.facebook_groups || []).forEach((gId: any) => {
        const id = gId._id?.toString() || gId.toString()
        if (!campaignGroupIds.includes(id)) campaignGroupIds.push(id)
      })
    })
    // Account-scoped extra groups (added to a shared library for THIS account only).
    ;(currentSlot.account_library_groups || []).forEach((gId: any) => {
      const id = gId.toString()
      if (!campaignGroupIds.includes(id)) campaignGroupIds.push(id)
    })
  }
  const accountExtraSet = new Set<string>((currentSlot?.account_library_groups || []).map((g: any) => g.toString()))
  const campaignLibs = (currentSlot?.group_libraries || []) as any[]

  const defaultHour = groupSettings.default_hour

  return (
    <div dir="rtl" style={{padding: '20px', maxWidth: '900px', margin: '0 auto'}}>
      <h1 style={{fontSize: '24px', fontWeight: 700, marginBottom: '24px'}}>תזמון קבוצות</h1>

      {loading ? (
        <div style={{textAlign: 'center', padding: '40px'}}>
          <div className="spinner-border text-primary" role="status" />
          <p style={{marginTop: '12px', color: '#666'}}>טוען...</p>
        </div>
      ) : campaigns.length === 0 ? (
        <div style={{
          textAlign: 'center',
          padding: '60px 20px',
          background: '#f8f9fa',
          borderRadius: '12px',
        }}>
          <p style={{fontSize: '16px', color: '#666'}}>אין קמפיינים</p>
        </div>
      ) : (
        <>
          {/* Campaign Picker */}
          <div style={{
            background: '#fff',
            borderRadius: '12px',
            padding: '20px',
            marginBottom: '16px',
            border: '1px solid #e9ecef',
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
          }}>
            <label style={{fontWeight: 600, fontSize: '14px', marginBottom: '8px', display: 'block'}}>
              בחר קמפיין:
            </label>
            <select
              value={selectedCampaign}
              onChange={(e) => handleCampaignChange(e.target.value)}
              style={{
                width: '100%',
                height: '42px',
                borderRadius: '8px',
                border: '1px solid #dee2e6',
                padding: '0 12px',
                fontSize: '14px',
                background: '#fff',
              }}
            >
              {campaigns.map((c: any) => (
                <option key={c._id} value={c._id}>{c.name}</option>
              ))}
            </select>
          </div>

          {/* Default Hour */}
          <div style={{
            background: '#fff',
            borderRadius: '12px',
            padding: '20px',
            marginBottom: '16px',
            border: '1px solid #e9ecef',
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
          }}>
            <label style={{fontWeight: 600, fontSize: '14px', marginBottom: '8px', display: 'block'}}>
              שעת פרסום ברירת מחדל:
            </label>
            <select
              value={defaultHour !== undefined && defaultHour !== null ? defaultHour : ''}
              onChange={(e) => {
                const val = e.target.value
                const newSettings = {...groupSettings}
                if (val === '') {
                  delete newSettings.default_hour
                } else {
                  newSettings.default_hour = parseInt(val)
                }
                setGroupSettings(newSettings)
              }}
              style={{
                width: '200px',
                height: '42px',
                borderRadius: '8px',
                border: '1px solid #dee2e6',
                padding: '0 12px',
                fontSize: '14px',
                background: '#fff',
              }}
            >
              <option value="">ללא (כל השעות 7-23)</option>
              {Array.from({length: 17}, (_, i) => i + 7).map(h => (
                <option key={h} value={h}>{h}:00</option>
              ))}
            </select>
          </div>

          {/* Account-scoped library additions */}
          {campaignLibs.length > 0 && (
            <div style={{
              background: '#fff',
              borderRadius: '12px',
              padding: '20px',
              marginBottom: '16px',
              border: '1px solid #e9ecef',
              boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
            }}>
              <h3 style={{fontSize: '16px', fontWeight: 600, margin: '0 0 4px'}}>הוספת קבוצות לספרייה (לחשבון זה בלבד)</h3>
              <p style={{fontSize: '13px', color: '#666', margin: '0 0 14px'}}>
                הקבוצות שתוסיפו כאן יתווספו לתזמון של החשבון שלכם בלבד — מבלי לשנות את הספרייה המשותפת או להשפיע על חשבונות אחרים.
              </p>

              {campaignLibs.length > 1 && (
                <div style={{marginBottom: '10px'}}>
                  <label style={{fontSize: '13px', fontWeight: 600, marginInlineEnd: '8px'}}>הוסף לספרייה:</label>
                  <select
                    value={libTarget || campaignLibs[0]?._id?.toString() || ''}
                    onChange={(e) => setLibTarget(e.target.value)}
                    style={{height: '36px', borderRadius: '8px', border: '1px solid #dee2e6', padding: '0 10px', fontSize: '13px'}}
                  >
                    {campaignLibs.map((lib: any) => (
                      <option key={lib._id} value={lib._id.toString()}>{lib.name || 'ספרייה'}</option>
                    ))}
                  </select>
                </div>
              )}

              {/* Search + add */}
              <div style={{position: 'relative'}}>
                <input
                  value={libSearchQ}
                  onChange={(e) => setLibSearchQ(e.target.value)}
                  placeholder="חיפוש קבוצה לפי שם להוספה…"
                  disabled={libBusy}
                  style={{width: '100%', height: '40px', borderRadius: '8px', border: '1px solid #dee2e6', padding: '0 12px', fontSize: '14px'}}
                />
                {(libSearchResults.length > 0 || libSearching) && (
                  <div style={{position: 'absolute', zIndex: 20, left: 0, right: 0, background: '#fff', border: '1px solid #e9ecef', borderRadius: '8px', marginTop: '4px', maxHeight: '260px', overflowY: 'auto', boxShadow: '0 6px 20px rgba(0,0,0,0.1)'}}>
                    {libSearching && <div style={{padding: '10px 12px', color: '#999', fontSize: '13px'}}>מחפש…</div>}
                    {libSearchResults.map((g: any) => {
                      const already = campaignGroupIds.includes(g._id.toString())
                      return (
                        <div key={g._id} onClick={() => { if (!already && !libBusy) addGroupToLibrary(g) }}
                          style={{display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 12px', cursor: already ? 'default' : 'pointer', opacity: already ? 0.5 : 1, borderBottom: '1px solid #f1f3f5'}}>
                          <img src={g.image_url || '/media/avatars/blank.png'} alt="" style={{width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover'}} onError={(e: any) => { e.target.src = '/media/avatars/blank.png' }} />
                          <div style={{flex: 1, minWidth: 0}}>
                            <div style={{fontSize: '13px', fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{g.name}</div>
                            {g.follow_count > 0 && <div style={{fontSize: '11px', color: '#888'}}>{formatFollowers(g.follow_count)} חברים</div>}
                          </div>
                          <span style={{fontSize: '12px', color: already ? '#999' : '#0d6efd', fontWeight: 600}}>{already ? 'כבר נמצאת' : '+ הוסף'}</span>
                        </div>
                      )
                    })}
                  </div>
                )}
              </div>

              {/* Current account-scoped extras */}
              {accountExtraSet.size > 0 && (
                <div style={{marginTop: '14px', display: 'flex', flexWrap: 'wrap', gap: '8px'}}>
                  {[...accountExtraSet].map((gId) => {
                    const g = groups[gId]
                    return (
                      <span key={gId} style={{display: 'inline-flex', alignItems: 'center', gap: '6px', background: '#eef5ff', border: '1px solid #cfe0ff', borderRadius: '999px', padding: '4px 10px', fontSize: '13px'}}>
                        {g?.name || gId}
                        <button onClick={() => removeGroupFromLibrary(gId)} disabled={libBusy}
                          title="הסר" style={{background: 'none', border: 'none', color: '#dc3545', cursor: 'pointer', fontSize: '14px', lineHeight: 1, padding: 0}}>✕</button>
                      </span>
                    )
                  })}
                </div>
              )}
            </div>
          )}

          {/* Groups List */}
          <div style={{
            background: '#fff',
            borderRadius: '12px',
            padding: '20px',
            marginBottom: '16px',
            border: '1px solid #e9ecef',
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
          }}>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px'}}>
              <h3 style={{fontSize: '16px', fontWeight: 600, margin: 0}}>
                קבוצות ({campaignGroupIds.length}):
              </h3>
              {Object.keys(groupSettings).filter(k => k !== 'default_hour').length > 0 && (
                <button
                  onClick={() => {
                    if (!window.confirm('למחוק את כל הגדרות התזמון לכל הקבוצות ואת שעת ברירת המחדל? כל הקבוצות יפורסמו בכל השעות (7-23).')) return
                    setGroupSettings({})
                    setExpandedGroup(null)
                  }}
                  style={{
                    background: '#dc3545',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '8px 16px',
                    fontSize: '13px',
                    fontWeight: 600,
                    cursor: 'pointer',
                  }}
                >
                  נקה הכל ({Object.keys(groupSettings).filter(k => k !== 'default_hour').length} הגדרות)
                </button>
              )}
            </div>

            {campaignGroupIds.length === 0 ? (
              <p style={{color: '#999', textAlign: 'center', padding: '20px'}}>
                אין קבוצות מוגדרות לקמפיין זה
              </p>
            ) : (
              <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                {campaignGroupIds.map((gId) => {
                  const group = groups[gId]
                  if (!group) return null
                  const gs = groupSettings[gId]
                  const hasCustom = gs && gs.schedule && Object.keys(gs.schedule).length > 0
                  const isExpanded = expandedGroup === gId

                  return (
                    <div key={gId} style={{
                      border: '1px solid #e9ecef',
                      borderRadius: '10px',
                      overflow: 'hidden',
                      background: hasCustom ? '#f0f4ff' : '#fff',
                    }}>
                      {/* Group Row */}
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '12px 16px',
                        gap: '12px',
                      }}>
                        <img
                          src={group.image_url || '/media/avatars/blank.png'}
                          alt=""
                          style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            objectFit: 'cover',
                            flexShrink: 0,
                          }}
                          onError={(e: any) => { e.target.src = '/media/avatars/blank.png' }}
                        />
                        <div style={{flex: 1, minWidth: 0}}>
                          <div style={{
                            fontWeight: 600,
                            fontSize: '14px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}>
                            {group.name}
                            {accountExtraSet.has(gId) && (
                              <span style={{marginInlineStart: '6px', fontSize: '10px', fontWeight: 700, color: '#0d6efd', background: '#eef5ff', borderRadius: '6px', padding: '1px 6px'}}>נוסף על ידך</span>
                            )}
                          </div>
                          {group.follow_count > 0 && (
                            <div style={{fontSize: '12px', color: '#888'}}>
                              {formatFollowers(group.follow_count)} חברים
                            </div>
                          )}
                        </div>

                        <span style={{
                          fontSize: '12px',
                          color: hasCustom ? '#0d6efd' : '#999',
                          whiteSpace: 'nowrap',
                          padding: '4px 8px',
                          background: hasCustom ? '#e7eeff' : '#f8f9fa',
                          borderRadius: '12px',
                        }}>
                          {hasCustom ? getSettingsSummary(gs) : 'ברירת מחדל'}
                        </span>

                        {hasCustom && (
                          <button
                            onClick={() => {
                              const newSettings = {...groupSettings}
                              delete newSettings[gId]
                              setGroupSettings(newSettings)
                              if (isExpanded) setExpandedGroup(null)
                            }}
                            style={{
                              background: 'none',
                              border: 'none',
                              color: '#dc3545',
                              cursor: 'pointer',
                              fontSize: '18px',
                              padding: '0 4px',
                              lineHeight: 1,
                            }}
                            title="נקה הגדרות"
                          >
                            ✕
                          </button>
                        )}

                        <button
                          onClick={() => setExpandedGroup(isExpanded ? null : gId)}
                          style={{
                            background: isExpanded ? '#0d6efd' : '#f0f0f0',
                            border: 'none',
                            color: isExpanded ? '#fff' : '#666',
                            cursor: 'pointer',
                            width: '32px',
                            height: '32px',
                            borderRadius: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '16px',
                            flexShrink: 0,
                          }}
                          title="הגדרות"
                        >
                          ⚙
                        </button>
                      </div>

                      {/* Expanded Settings */}
                      {isExpanded && (
                        <div style={{padding: '0 16px 16px'}}>
                          <GroupSettings
                            groupId={gId}
                            settings={gs || {schedule: {}}}
                            onChange={(newGs) => {
                              setGroupSettings({...groupSettings, [gId]: newGs})
                            }}
                            onClear={() => {
                              const newSettings = {...groupSettings}
                              delete newSettings[gId]
                              setGroupSettings(newSettings)
                            }}
                          />
                        </div>
                      )}
                    </div>
                  )
                })}
              </div>
            )}
          </div>

          {/* Save Button */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            marginTop: '20px',
          }}>
            <button
              onClick={handleSave}
              disabled={saving}
              style={{
                background: 'linear-gradient(135deg, #0d6efd, #0b5ed7)',
                color: '#fff',
                border: 'none',
                borderRadius: '10px',
                padding: '12px 32px',
                fontSize: '16px',
                fontWeight: 600,
                cursor: saving ? 'not-allowed' : 'pointer',
                opacity: saving ? 0.7 : 1,
              }}
            >
              {saving ? 'שומר...' : 'שמור'}
            </button>
            {saveMessage && (
              <span style={{
                color: saveMessage.includes('שגיאה') ? '#dc3545' : '#198754',
                fontSize: '14px',
                fontWeight: 500,
              }}>
                {saveMessage}
              </span>
            )}
          </div>
        </>
      )}
    </div>
  )
}

export {GroupSchedulingWrapper}
